import React from "react";
import { formatDate } from "../../../helpers/helpers.jsx";
import { CD } from "./CD08.json";
import { text01, text02, postTitle } from "./Post04.json";

const BlogPost = ({ lang }) => {
  return (
    <div className="postContainer">
      <div className="postHeader">
        <h1 className="postTitle">{postTitle[lang]}</h1>
        <span className="postedBy">{formatDate(lang, "2022-01-30")}</span>
      </div>
      <div className="postText postText-center">
        <div className="postImageContainer-50">
          <img src="mp3/CD8/cover.jpg" alt="cd08" />
        </div>
        <p style={{ textAlign: "center" }}>
          {text01[lang]} <br />
          <br /> {text02[lang]} <br />
        </p>
        <div className="postText postText-left postText-small">
          <table className="postTableAlternate">
            <tbody>
              {CD.tracks.map((track, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{track.title}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <br />
        {CD.info[lang]}
      </div>
    </div>
  );
};

export default BlogPost;



// WEBPACK FOOTER //
// ./src/components/Home/post04/Post04.jsx